import { render, staticRenderFns } from "./singleReceivable.vue?vue&type=template&id=c134eea0"
import script from "./singleReceivable.vue?vue&type=script&lang=js"
export * from "./singleReceivable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports